var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParagraphImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "292px",
    height: "350px",
    viewBox: "0 0 292 350",
    style: {
      enableBackground: "new 0 0 292 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6790C9;}\n\t.st1{opacity:0.3;fill:#6790C9;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.71,169.96c8.19-5.04,12.29-11.34,12.29-18.9c0-5.95-1.99-10.64-5.99-14.07 c-3.99-3.43-10.04-6.34-18.13-8.75c-5.46-1.61-9.45-2.98-11.97-4.1c-2.52-1.12-4.2-2.2-5.04-3.32s-1.26-2.52-1.26-4.24 c0-4.55,3.85-6.79,11.51-6.79c7.03,0,13.96,1.82,20.82,5.43l8.37-13.44c-4.2-2.63-8.93-4.69-14.18-6.2s-10.68-2.28-16.24-2.28 c-6.82,0-12.81,1.05-17.88,3.11c-5.11,2.07-9.03,4.94-11.83,8.61c-2.8,3.67-4.17,7.84-4.17,12.46c0,3.53,0.7,6.61,2.07,9.2 c1.37,2.62,3.57,4.97,6.62,7.1c-8.4,4.94-12.6,11.13-12.6,18.59c0,5.95,1.96,10.6,5.85,13.96c3.89,3.36,9.87,6.26,17.99,8.68 c5.57,1.61,9.66,3.01,12.29,4.16s4.38,2.28,5.21,3.4s1.26,2.52,1.26,4.24c0,2.1-1.08,3.74-3.22,4.9c-2.17,1.15-5.21,1.75-9.24,1.75 c-7.04,0-13.97-1.93-20.83-5.74l-8.05,14.07c8.29,5.43,18.34,8.15,30.1,8.15c7.04,0,13.2-1.01,18.45-3.01 c5.25-2.03,9.35-4.83,12.21-8.47c2.9-3.64,4.34-7.81,4.34-12.53c0-3.74-0.7-6.82-2.07-9.31 C202.96,174.2,200.76,171.96,197.71,169.96z M187.15,158.93c-0.74,1.61-1.75,3.18-3.01,4.69c-1.47-0.6-4.9-1.85-10.25-3.78 c-4.73-1.61-7.95-3.18-9.62-4.69c-1.68-1.51-2.52-3.57-2.52-6.19c0-3.01,1.12-5.95,3.32-8.75l7.74,2.55 c6.09,1.93,10.18,3.68,12.29,5.29c2.1,1.61,3.15,3.74,3.15,6.33C188.23,155.79,187.88,157.32,187.15,158.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.69,326.65h-17.53v-23.7c6.33-0.79,12.26-2.85,17.53-5.91v-40.4c0,12.92-10.46,23.35-23.34,23.35H70 c-4.09,0-8.02,0.7-11.65,1.99V46.65c0-12.88,10.43-23.31,23.31-23.34h186.69c12.91,0,23.34,10.47,23.34,23.34V6.28 C284.81,2.29,276.83,0,268.31,0H81.66C55.9,0,35,20.9,35,46.65v262.5c0,0.74,0.07,1.43,0.21,2.1c-0.14,1.22-0.21,2.45-0.21,3.71 c0,19.32,15.68,35,35,35h221.69V326.65z M250.85,326.65H70c-6.44,0-11.65-5.21-11.65-11.65s5.21-11.66,11.65-11.66h180.85V326.65z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphImage);
export default __webpack_public_path__ + "static/media/paragraphImage.fd3349185d0934103d06b0e61237def1.svg";
export { ForwardRef as ReactComponent };